import { render, staticRenderFns } from "./DashboardTotals.vue?vue&type=template&id=07558dfa&"
import script from "./DashboardTotals.vue?vue&type=script&lang=js&"
export * from "./DashboardTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports